import { TableHeadersType } from '../../../constant/tableHeadersConstants/tableHeadersType';
import { tableEditIcon } from '../../../assets/images';
import { MasterEmailerList } from '../../../redux/masterData/masterTypes';
import UpdatedByAndUpdatedAt from '../../commons/CommonUpdatedByAndUpdatedAt';
import { formateDateTime } from '../../../utils/commonFunctions';
type AppProps = {
    data: MasterEmailerList[]|[];
    tableHeader: TableHeadersType[];
    handleEditMasterEmailer: (data:MasterEmailerList)=>void;
    handleChangeStatus:(data:MasterEmailerList)=>void;
    isUpdateEmailPresent:boolean;
}
const EmailersTableData = ({
    data,
    tableHeader,
    handleEditMasterEmailer,
    handleChangeStatus,
    isUpdateEmailPresent
}: AppProps) => {
    return (
        <>
              {data?.length > 0 &&
        data?.map((emailerData: any) => {
          return (
            <tr className="text-left">
              {tableHeader?.length > 0 &&
                tableHeader?.map((header: TableHeadersType) => {
                  if (header?.value == "email_name") {
                    return (
                      <td className="text-left" style={{ minWidth:"200px" }}>
                        {emailerData?.email_name}
                      </td>
                    );
                  } 
                  else if (header?.value == "subject") {
                    return (
                      <td className="text-left" style={{ minWidth:"180px" }}>
                        {emailerData?.subject
                }
                      </td>
                    );
                  } 
                  else if (header?.value == "description") {
                    return (
                      <td className="text-left" style={{ minWidth:"310px" }}>
                        {emailerData?.description
                }
                      </td>
                    );
                  } 
                  else if (header?.value === "updated_by") {
                    return (
                      <td style={{width:'180px'}}>
                         <UpdatedByAndUpdatedAt
                          firstName={emailerData?.updated_by?.first_name}
                          lastName={emailerData?.updated_by?.last_name}
                          profilePic={emailerData?.updated_by?.profile_pic?.file_url}
                          updatedAt={formateDateTime(emailerData?.updated_at)}
              />
                        
                      </td>
                    );
                  }
                
                else if (header?.value === "status") {
                    return <td className="text-left">
                             <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "3px",
                      }}
                    >
                      <label className="switchs m-0">
                        <input
                          type="checkbox"
                          checked={emailerData?.status===true ? true : false}
                          onChange={() =>
                            handleChangeStatus(emailerData)
                          }
                        />
                        <span
                          className="sliders rounds"
                        ></span>
                      </label>
                    </div>
                    </td>
                }  
                  else if (header?.value == "Edit") {
                    return (
                      <td style={{ textAlign: "center" }}>
                        {isUpdateEmailPresent &&
                        <span  className="d-inline-block pointer" onClick={()=>handleEditMasterEmailer(emailerData)}> 
                          <div
                            style={{
                              color: "#d43",
                              fontSize: 20,
                            }}
                          >
                            <img src={tableEditIcon}alt ="edit"/>

                          </div>
                        </span>
                        }
                      </td>
                    );
                  }
                  return null;
                })}
            </tr>
          );
        })}
    </>

    )
}

export default EmailersTableData;